import { UnitManagePage } from '@apps-common/apps/portal/pages/units/pages/manage/Index'

export const UnitManage = () => <UnitManagePage />
